import {ReactElement} from 'react';
import {Adapter as AdapterType} from 'ui/adapters/types';
import {deviceService} from 'interactors/deviceProxy';

export interface AdapterProps {
  children: (isInstallable: boolean) => ReactElement;
}

interface FactoryDependencies {
  service?: DeviceService;
}

export function createAdapter(di: FactoryDependencies = {}): AdapterType<AdapterProps> {
  const {service = deviceService} = di;

  return function Adapter({children}: AdapterProps): ReactElement {
    return children(service.canInstallApp());
  };
}

export const IsInstallable = createAdapter();
